import React, { useState, useEffect } from 'react';
import axios from "axios";
import { baseUrl } from "../../shared/baseUrl";
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import { addPropertyAction } from "../../redux/actions/propertyActions";
import { ADD_PROPERTY_RESET } from "../../redux/constants/propertyConstants";
import { states, lgas, propertyTypes } from '../../data/PropertyData';
import { NewLGA } from '../../data/NewLGA';
import Swal from 'sweetalert2';
import { MdCloudUpload } from 'react-icons/md';

const AddProperty = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [toggleNav, setToggleNav] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const addProperty = useSelector(state => state.addProperty)
  const { loading, success, error } = addProperty

  // --- Property States --- //
  const [title, setTitle] = useState("")
  const [price, setPrice] = useState("")
  const [state, setState] = useState("")
  const [lga, setLga] = useState("")
  const [newLga, setNewLga] = useState([])
  const [address, setAddress] = useState("")
  const [category, setCategory] = useState("")
  const [propertyType, setPropertyType] = useState("")
  const [bedrooms, setBedrooms] = useState("")
  const [bath, setBath] = useState("")
  const [toilet, setToilet] = useState("")
  const [parkingSpace, setParkingSpace] = useState("")
  const [square, setSquare] = useState("")
  const [furnished, setFurnished] = useState("")
  const [serviced, setServiced] = useState("")
  const [shared, setShared] = useState("")
  const [description, setDescription] = useState("")

  const [images, setImages] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)

  useEffect(() => {
    document.title = "Island Luxury - Post Property"
    if(!userInfo) {
			navigate('/')
		}
    if(error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error}`
      })
    }
    if(success) {
      Swal.fire({
        icon: 'success',
        title: 'Saved',
        text: "Your property have been saved!",
      })
      setTitle("")
      setPrice("")
      setState("")
      setLga("")
      setAddress("")
      setCategory("")
      setPropertyType("")
      setBedrooms("")
      setBath("")
      setToilet("")
      setParkingSpace("")
      setSquare("")
      setFurnished("")
      setServiced("")
      setShared("")
      setDescription("")
      setImages([])
      dispatch({
        type: ADD_PROPERTY_RESET
      })
    }
  }, [dispatch, userInfo, navigate, loading, success, error])

  useEffect(() => {
    NewLGA({state, lgas, setNewLga })
  }, [state])

  const handleAddProperty = (e) => {
    e.preventDefault()
    dispatch(addPropertyAction(
      title,
      price,
      state,
      lga,
      address,
      category,
      propertyType,
      bedrooms,
      bath,
      toilet,
      parkingSpace,
      square,
      furnished,
      serviced,
      shared,
      description,
      images
    ))
  }

  const handleUploadMultiImg = async (e) => {
    const files = e.target.files
    let formData = new FormData()

    for(const file of files){
      formData.append("image", file)
    }

    try {
      setLoadingUpload(true)
      const data = await axios.post(baseUrl + "/api/v1/imageupload/multiple", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${userInfo?.token}`
        }
      })
      setImages(data.data.IMAGES)
      setLoadingUpload(false)
    }
    catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${err.response && err.response.data.message ? err.response.data.message : err.message}, please try again!`,
      })
      setLoadingUpload(false)
    }
  }

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="add-property">
        <section className="page-title">
          <h3><NavLink to="/dashboard">Dashboard</NavLink> | Post Property</h3>
          {/* <div className="page-title_extra">
            <p>You are entiled to 10 free posts, however you can subscribe to our different plans to have access to unlimited posts. <NavLink to="/plans">Choose Plan</NavLink></p>
            <p>You have <span>10</span> free post(s) left</p>
          </div> */}
        </section>
        <section className="add-property_form">
          <form onSubmit={handleAddProperty}>
            <div className="form-grp">
              <label htmlFor="title">Title<span>*</span></label>
              <input 
                type="text" 
                id="title" 
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="price">Price<span>*</span></label>
              <input 
                type="number" 
                id="price" 
                placeholder="₦" 
                required
                value={price}
                onChange={(e) => setPrice(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="state">State<span>*</span></label>
              <select 
                id="state" 
                required
                value={state}
                onChange={(e) => setState(e.target.value)}>
                <option></option>
                {states.map((item, index) => 
                  <option key={index} value={item}>{item}</option>
                )}
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="l.g.a">L.G.A<span>*</span></label>
              <select 
                id="l.g.a" 
                required
                value={lga}
                onChange={(e) => setLga(e.target.value)}>
                <option></option>
                {state && 
                  newLga.map((item, index) => 
                    <option key={index} value={item}>{item}</option>
                  )
                }
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="address">Geographical Area<span>*</span></label>
              <input 
                type="text" 
                id="address" 
                required
                value={address}
                onChange={(e) => setAddress(e.target.value)}/>
            </div>
            <div className="form-grp">
              <label htmlFor="category">Category<span>*</span></label>
              <select 
                id="category" 
                required
                value={category}
                onChange={(e) => setCategory(e.target.value)}>
                <option></option>
                <option value="Rent">Rent</option>
                <option value="Sale">Sale</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="type">Property Type<span>*</span></label>
              <select 
                id="type" 
                required
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}>
                <option></option>
                {propertyTypes.map((item, index) => 
                  <option key={index} value={item}>{item}</option>
                )} 
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="beds">Bedrooms</label>
              <input 
                type="number" 
                id="beds" 
                min={1} max={20} 
                value={bedrooms}
                onChange={(e) => setBedrooms(e.target.value)}/>
            </div>
            <div className="form-grp">
              <label htmlFor="baths">Baths</label>
              <input 
                type="number" 
                id="baths" 
                min={1} max={20} 
                value={bath}
                onChange={(e) => setBath(e.target.value)}/>
            </div>
            <div className="form-grp">
              <label htmlFor="toilets">Toilets</label>
              <input 
                type="number" 
                id="toilets" 
                min={1} max={20}
                value={toilet}
                onChange={(e) => setToilet(e.target.value)} />
            </div>
            <div className="form-grp">
              <label htmlFor="parking">Parking Space</label>
              <select 
                id="parking" 
                value={parkingSpace}
                onChange={(e) => setParkingSpace(e.target.value)}>
                <option></option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="sqr-ft">Square ft (optional)</label>
              <input 
                type="number" 
                id="sqr-ft" 
                value={square}
                onChange={(e) => setSquare(e.target.value)}/>
            </div>
            <div className="form-grp">
              <label htmlFor="furnished">Furnished</label>
              <select 
                id="furnished" 
                value={furnished}
                onChange={(e) => setFurnished(e.target.value)}>
                <option></option>
                <option value={true}>Furnished</option>
                <option value={false}>Unfurnished</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="serviced">Serviced</label>
              <select 
                id="serviced" 
                value={serviced}
                onChange={(e) => setServiced(e.target.value)}>
                <option></option>
                <option value={true}>Serviced</option>
                <option value={false}>Unserviced</option>
              </select>
            </div>
            <div className="form-grp">
              <label htmlFor="shared">Shared</label>
              <select 
                id="shared" 
                value={shared}
                onChange={(e) => setShared(e.target.value)}>
                <option></option>
                <option value={true}>Shared</option>
                <option value={false}>Unshared</option>
              </select>
            </div>
            <div className="form-grp upload-imgs textarea">
              <label className="custom-upload" title="Click to Upload Images" >
                <input
                  multiple
                  type="file"
                  accept="image/*"
                  onChange={handleUploadMultiImg}
                  disabled={loadingUpload && true} />
                <MdCloudUpload size={60} />
                {loadingUpload ? 
                  <p>Setting images...</p>
                :
                  <p>Click to choose images</p>
                }
              </label>
              <div className="upload-imgs_alert">
                <h4>Image Requirements. Please Note!</h4>
                <p>Maximum File Size: 1MB</p>
                <p>Maximum Dimensions: 2000x2000 pixels</p>
                <p>Need to resize your image? <a href="https://squoosh.app/" target="_blank">https://squoosh.app/</a></p>
              </div>
              {images.length > 0 &&
                <div className="prev-imgs">
                  {images.map((img, i) =>
                    <img key={i} src={`${baseUrl}/${img}`} alt={`Property image ${i}`} />
                  )}
                </div>
              }
            </div>
            <div className="form-grp textarea">
              <label htmlFor="description">Description<span>*</span></label>
              <textarea 
                id="description" 
                rows="5" 
                required
                value={description}
                onChange={(e) => setDescription(e.target.value)}/>
            </div>
            <div className="form-grp_btn">
              <button type="submit" disabled={loading && true}>{loading ? "Posting..." : "Post"}</button>
            </div>
          </form>
        </section>
      </main>
    </div>
  )
}

export default AddProperty;